<template>
  <div style="position: relative;">
    <el-form ref="demonstrationBaseFilter" :model="demonstrationBaseList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="示范基地名称" prop="formFilter.name">
          <el-input class="filter-item" v-model="demonstrationBaseList.formFilter.name"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="地址" prop="formFilter.address">
          <el-input class="filter-item" v-model="demonstrationBaseList.formFilter.address"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="联系人" prop="formFilter.contactPerson">
          <el-input class="filter-item" v-model="demonstrationBaseList.formFilter.contactPerson"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="是否存在" prop="formFilter.isExist">
          <el-select v-model="demonstrationBaseList.formFilter.isExist" placeholder="请选择" clearable>
            <el-option label="存在" value="1"></el-option>
            <el-option label="不存在" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否六有标准" prop="formFilter.isSixStandards">
          <el-select v-model="demonstrationBaseList.formFilter.isSixStandards" placeholder="请选择" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetDemonstrationBase">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshDemonstrationBase(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('demonstrationBase:all')"
                   @click="handleAdd">
          新增
        </el-button>
        <el-button slot="operator" type="success" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('demonstrationBase:all')"
                   @click="handleImport">
          导入
        </el-button>
      </filter-box>
    </el-form>

      <!-- 列表区 -->
      <div class="table-area">
        <el-table ref="demonstrationBase" :data="demonstrationBaseList.DemonstrationBase.impl.dataList" :size="defaultFormItemSize" @sort-change="demonstrationBaseList.DemonstrationBase.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="demonstrationBaseList.DemonstrationBase.impl.currentRowChange"
                  v-loading="demonstrationBaseList.DemonstrationBase.impl.loading"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="demonstrationBaseList.DemonstrationBase.impl.getTableIndex" />
          <el-table-column label="示范基地名称" prop="name" sortable="custom" width="200">
          </el-table-column>
          <el-table-column label="地址" prop="address" width="300">
          </el-table-column>
          <el-table-column label="联系人" prop="contactPerson" width="120">
          </el-table-column>
          <el-table-column label="联系电话" prop="contactPhone" width="150">
          </el-table-column>
          <el-table-column label="是否存在" prop="isExist" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isExist === 1 ? 'success' : 'danger'">
                {{ scope.row.isExist === 1 ? '存在' : '不存在' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否六有标准" prop="isSixStandards" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isSixStandards === 1 ? 'success' : 'info'">
                {{ scope.row.isSixStandards === 1 ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="经度" prop="longitude" width="120">
          </el-table-column>
          <el-table-column label="纬度" prop="latitude" width="120">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom" width="180">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="demonstrationBaseList.DemonstrationBase.impl.totalCount"
            :current-page="demonstrationBaseList.DemonstrationBase.impl.currentPage"
            :page-size="demonstrationBaseList.DemonstrationBase.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="demonstrationBaseList.DemonstrationBase.impl.onCurrentPageChange"
            @size-change="demonstrationBaseList.DemonstrationBase.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <demonstration-base-form
        ref="demonstrationBaseForm"
        :demonstration-base="dialogDemonstrationBase"
        :edit-mode="isEditMode"
        @save="handleSave"
        @cancel="handleCancel"
      ></demonstration-base-form>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog title="导入示范基地信息" :visible.sync="demonstrationBaseList.importDialogVisible" width="500px" :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :auto-upload="false"
        :on-change="onFileChange"
        :file-list="demonstrationBaseList.fileList"
        accept=".xlsx,.xls"
        drag
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xlsx/xls格式文件，且不超过10MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button :size="defaultFormItemSize" @click="demonstrationBaseList.importDialogVisible = false">取消</el-button>
        <el-button type="primary" :size="defaultFormItemSize" :loading="demonstrationBaseList.isImporting" @click="onImportSubmitClick">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TableWidget } from '@/utils/widget.js';
import DemonstrationBaseForm from './demonstrationBaseForm.vue';
import { DemonstrationBaseController } from '@/api';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { findItemFromList } from '@/utils';

export default {
  name: 'DemonstrationBaseList',
  components: {
    DemonstrationBaseForm
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      defaultFormItemSize: 'small',
      // 示范基地列表
      demonstrationBaseList: {
        formFilter: {
          name: undefined,
          address: undefined,
          contactPerson: undefined,
          isExist: undefined,
          isSixStandards: undefined
        },
        formFilterCopy: {
          name: undefined,
          address: undefined,
          contactPerson: undefined,
          isExist: undefined,
          isSixStandards: undefined
        },
        DemonstrationBase: {
          impl: new TableWidget(this.loadDemonstrationBaseWidgetData, this.loadDemonstrationBaseVerify, true, true)
        },
        importDialogVisible: false,
        isImporting: false,
        fileList: [],
        isInit: false
      },
      // 弹窗
      dialogVisible: false,
      dialogTitle: '',
      isEditMode: false,
      dialogDemonstrationBase: {}
    };
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  methods: {
    // 重置
    onResetDemonstrationBase () {
      this.$refs.demonstrationBaseFilter.resetFields();
      this.refreshDemonstrationBase(true);
    },

    // 加载示范基地表格数据
    loadDemonstrationBaseWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        demonstrationBaseDtoFilter: {
          name: this.demonstrationBaseList.formFilterCopy.name,
          address: this.demonstrationBaseList.formFilterCopy.address,
          contactPerson: this.demonstrationBaseList.formFilterCopy.contactPerson,
          isExist: this.demonstrationBaseList.formFilterCopy.isExist,
          isSixStandards: this.demonstrationBaseList.formFilterCopy.isSixStandards
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        DemonstrationBaseController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          if (this.demonstrationBaseList.DemonstrationBase.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.demonstrationBaseList.DemonstrationBase.impl.currentRow.id, 'id');
              this.$refs.demonstrationBase.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },

    // 验证示范基地表格数据
    loadDemonstrationBaseVerify (data) {
      return true;
    },

    // 刷新示范基地列表
    refreshDemonstrationBase (resetPage) {
      this.demonstrationBaseList.formFilterCopy = JSON.parse(JSON.stringify(this.demonstrationBaseList.formFilter));
      if (resetPage) {
        this.demonstrationBaseList.DemonstrationBase.impl.refreshTable(true, 1);
      } else {
        this.demonstrationBaseList.DemonstrationBase.impl.refreshTable();
      }
      if (!this.demonstrationBaseList.isInit) {
        // 初始化下拉数据
      }
      this.demonstrationBaseList.isInit = true;
    },

    onResume () {
      this.refreshDemonstrationBase();
    },
    formInit () {
      this.refreshDemonstrationBase();
    },

    // 新增
    handleAdd () {
      this.isEditMode = false;
      this.dialogTitle = '新增示范基地';
      this.dialogDemonstrationBase = {};
      this.dialogVisible = true;
    },

    // 编辑
    handleEdit (row) {
      this.isEditMode = true;
      this.dialogTitle = '编辑示范基地';
      this.dialogDemonstrationBase = Object.assign({}, row);
      this.dialogVisible = true;
    },

    // 删除
    handleDelete (row) {
      this.$confirm('确定要删除该示范基地吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DemonstrationBaseController.delete(this, { id: row.id }).then(res => {
          this.$message.success('删除成功');
          this.refreshDemonstrationBase(false);
        }).catch(e => {
          this.$message.error('删除失败');
        });
      }).catch(() => {
        // 取消删除
      });
    },

    // 导入
    handleImport () {
      this.demonstrationBaseList.fileList = [];
      this.demonstrationBaseList.importDialogVisible = true;
    },

    onFileChange (file, fileList) {
      this.demonstrationBaseList.fileList = fileList.slice(-1);
    },

    onImportSubmitClick () {
      if (this.demonstrationBaseList.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.demonstrationBaseList.isImporting = true;
      let formData = new FormData();
      formData.append('file', this.demonstrationBaseList.fileList[0].raw);
      DemonstrationBaseController.importData(this, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.success) {
          let data = res.data;
          this.$message.success(`导入完成：成功${data.successCount}条，失败${data.failCount}条`);
          if (data.failMessages && data.failMessages.length > 0) {
            this.$alert(data.failMessages.join('<br/>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.demonstrationBaseList.importDialogVisible = false;
          this.refreshDemonstrationBase(true);
        } else {
          this.$message.error(res.message);
        }
      }).catch(e => {
        this.$message.error('导入失败');
      }).finally(() => {
        this.demonstrationBaseList.isImporting = false;
      });
    },

    // 保存
    handleSave () {
      this.dialogVisible = false;
      this.refreshDemonstrationBase();
    },

    // 取消
    handleCancel () {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
.demonstration-base-list-page {
  padding: 10px;
}

.search-area {
  margin-bottom: 20px;
}

.table-area {
  margin-top: 20px;
}
</style>
